// extracted by mini-css-extract-plugin
module.exports = {"Icon__root":"tS_m","Icon__root_inline":"q4ZU","Icon__root_flex":"RbRf","Icon__img":"DLyA","Icon__img_inline":"pi5C"};